import { UserRequestParams } from './mobileVerifyRequestTypes';
import { decodeDecryptValue, encodeEncryptStr } from '../shared/basicEncryption';
import { MV_BASIC_ENCRYPTION_KEY } from '../shared/consts';

export function parseEncryptedParamsJson(encryptedParam: string): UserRequestParams | undefined {
    if (!encryptedParam) return;
    try {
        const decryptedStr = decodeDecryptValue(encryptedParam, MV_BASIC_ENCRYPTION_KEY);
        if (!decryptedStr) return;
        const decryptedFields = JSON.parse(decryptedStr);
        return decryptedFields;
    } catch (e) {
        return;
    }
}

export function encryptParams(paramsDict: UserRequestParams): string | undefined {
    if (!paramsDict) return;
    try {
        const paramsJson = JSON.stringify(paramsDict);
        const encryptedVal = encodeEncryptStr(paramsJson, MV_BASIC_ENCRYPTION_KEY);
        if (!encryptedVal) return;
        return encryptedVal;
    } catch (e) {
        return;
    }
}
